// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planning .steps {
  width: 100%;
  min-height: calc(100vh - 56px);
  padding-bottom: 70px;
}
.planning .steps__header ul {
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
}
.planning .steps__header ul li {
  width: 100%;
  height: 8px;
  display: flex;
  align-items: center;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  border: 1px solid #b6bfc8;
  background-color: var(--sebrae-purple);
  color: var(--sebrae-white);
  padding: 0 16px;
}
.planning .steps__header ul li:nth-child(1) {
  background-color: #994599;
  border-color: #994599;
}
.planning .steps__header ul li:nth-child(2) {
  background-color: #5c8fd6;
  border-color: #5c8fd6;
}
.planning .steps__header ul li:nth-child(3) {
  background-color: #005eb8;
  border-color: #005eb8;
}
.planning .steps__header ul li:nth-child(4) {
  background-color: #0f438a;
  border-color: #0f438a;
}
.planning .steps__header ul li:nth-child(5) {
  background-color: #0024a9;
  border-color: #0024a9;
}
.planning .steps__header ul li:nth-child(6) {
  background-color: #142e52;
  border-color: #142e52;
}
.planning .steps__header ul li:nth-child(7) {
  background-color: #0a1729;
  border-color: #0a1729;
}
.planning .steps__header ul li:nth-child(8) {
  background-color: #14adcc;
  border-color: #14adcc;
}
.planning .steps__header ul li:nth-child(9) {
  background-color: #0e778b;
  border-color: #0e778b;
}
.planning .steps__header ul li:nth-child(10) {
  background-color: #094f5d;
  border-color: #094f5d;
}
.planning .steps__header ul li p {
  font-family: var(--font-lato);
  font-size: 13px;
  font-weight: 700;
  visibility: hidden;
}
.planning .steps__header ul li.has-name {
  padding: 8px 16px;
  height: 32px;
}
.planning .steps__header ul li.has-name p {
  visibility: visible;
}
.planning .steps__header ul li.active {
  padding: 8px 16px;
  height: 55px;
}
.planning .steps__header ul li.active p {
  font-size: 17px;
  visibility: visible;
}
@media screen and (max-width: 767px) {
  .planning .steps__header.expanded ul li {
    height: 33px;
  }
  .planning .steps__header.expanded ul li p {
    font-size: 13px;
    visibility: visible;
  }
}
.planning .steps__body {
  padding: 16px 0;
}
.planning .steps .step h5 {
  margin: 16px 0;
}
.planning .steps .total-investment .BaSe--input .BaSe--input-wrapper {
  width: 50%;
}
.planning .steps .receipt-deadline .installments,
.planning .steps .payment-terms .installments {
  margin: 15px 0;
}
.planning .steps .receipt-deadline .installments .custom-input-range,
.planning .steps .payment-terms .installments .custom-input-range {
  margin: 0;
}
.planning .steps .receipt-deadline .btn-add-more,
.planning .steps .payment-terms .btn-add-more {
  width: 24px;
  display: block;
  margin: 24px auto;
}
.planning .steps .receipt-deadline .wrapper-button-secondary,
.planning .steps .payment-terms .wrapper-button-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px auto;
}
.planning .steps .receipt-deadline .wrapper-button-secondary button,
.planning .steps .payment-terms .wrapper-button-secondary button {
  border-color: var(--sebrae-white);
  font-size: 13px;
}
.planning .steps .receipt-deadline .wrapper-button-secondary button span,
.planning .steps .payment-terms .wrapper-button-secondary button span {
  font-size: inherit;
}
.planning .steps .inventory-turnover .btn-add-more {
  width: 24px;
  display: block;
  margin: 10px auto 16px;
}
.planning .steps .inventory-turnover .grid-buttons-area div {
  align-items: center;
}
.planning .steps .inventory-turnover .grid-buttons-area .top-input {
  padding-left: 4px;
}
@media (max-width: 320px) {
  .planning .steps .inventory-turnover .grid-buttons-area .top-input {
    padding-left: 8px;
  }
}
.planning .steps .inventory-turnover .grid-buttons-area .remove-button {
  padding-top: 17px;
}
.planning .steps .inventory-turnover form {
  max-width: 389px;
}
.planning .steps .inventory-turnover .result p {
  color: var(--sebrae-blue);
  font-size: 11px;
  font-weight: 400;
  margin: 0;
}
.planning .steps .inventory-turnover .result input {
  margin-right: 6px;
}
@media (max-width: 380px) {
  .planning .steps .inventory-turnover .result input {
    margin-right: 10px;
  }
}
@media (max-width: 320px) {
  .planning .steps .inventory-turnover .result input {
    margin-right: 13px;
  }
}
.planning .steps .inventory-turnover .result .input-100 .BaSe--input {
  margin: 0;
}
.planning .steps .inventory-turnover .result .input-100 .BaSe--input .BaSe--input-wrapper {
  border-radius: 4px;
  overflow: hidden;
}
.planning .steps .inventory-turnover .result .input-100 .BaSe--input input {
  background: var(--sebrae-white);
  border-radius: 4px;
  border-width: 2px;
  border-image-slice: 1;
  border-image-source: linear-gradient(to right, #3b4aff 0%, #40bbff 100%);
}
.planning .steps .inventory-turnover .result .input-not-100 .BaSe--input {
  margin: 0;
}
.planning .steps .inventory-turnover .result .input-not-100 .BaSe--input .BaSe--input-wrapper {
  border-radius: 4px;
  overflow: hidden;
}
.planning .steps .inventory-turnover .result .input-not-100 .BaSe--input input {
  background: var(--sebrae-white);
  border-radius: 4px;
  border-width: 2px;
  border-image-slice: 1;
  border-image-source: linear-gradient(to right, #ff3b3b 0%, #760303 100%);
}
.planning .steps .inventory-turnover .result .BaSe--grid-item:first-of-type {
  align-self: end;
}
.planning .steps .guarantees p {
  font-size: 13px;
  font-weight: 400;
  color: #181a1b;
  margin: 15px 0;
  max-width: 493px;
}
.planning .steps .guarantees form {
  max-width: 596px;
}
.planning .steps .guarantees form .BaSe--grid,
.planning .steps .guarantees form .wrapper-select {
  max-width: 252px;
  margin: 0;
}
.planning .steps .guarantees .group-input {
  padding-bottom: 15px;
  margin-bottom: 15px;
}
@media (min-width: 1280px) {
  .planning .steps .guarantees .group-input.gi-space {
    padding-bottom: 60px;
  }
}
.planning .steps .guarantees .group-input .BaSe--input {
  margin-bottom: 0;
}
.planning .steps .guarantees .group-input #greenStatus {
  color: #00662a !important;
  background-color: #c2efd1 !important;
  border: 1px solid #85e0a3 !important;
}
.planning .steps .guarantees .group-input #redStatus {
  color: #bf303c !important;
  background-color: #f3d8da !important;
  border: 1px solid #bf303c !important;
}
.planning .steps .guarantees .group-input #yellowStatus {
  color: #664d1a !important;
  background-color: #ffeecc !important;
  border: 1px solid #ffbf40 !important;
}
.planning .steps .guarantees .box-fampe {
  width: 100%;
  max-width: 252px;
  border-radius: 8px;
  border: 1px solid var(--sebrae-light-gray-2);
  background: var(--sebrae-white);
  box-shadow: 0 4px 8px 0 rgba(20, 46, 82, 0.2);
  padding: 16px;
  color: var(--sebrae-blue);
}
.planning .steps .guarantees .box-fampe p {
  font-size: 16px;
  margin: 0 0 16px;
  color: inherit;
}
.planning .steps .guarantees .box-fampe a {
  color: inherit;
  text-decoration: underline;
}
@media screen and (min-width: 768px) {
  .planning .steps .guarantees .planning__footer {
    justify-content: baseline;
  }
  .planning .steps .guarantees .BaSe--grid {
    position: static;
  }
}
@media screen and (min-width: 1280px) {
  .planning .steps .guarantees form {
    width: 100%;
  }
  .planning .steps .guarantees form .BaSe--grid {
    max-width: 100%;
  }
  .planning .steps .guarantees form .wrapper-select,
  .planning .steps .guarantees form .BaSe--input {
    max-width: 286px;
  }
  .planning .steps .guarantees .box-fampe {
    max-width: 286px;
    margin: 0 0 0 auto;
  }
}
.planning .steps .results {
  max-width: 612px;
}
.planning .steps .results .notes-modal span {
  font-weight: bold;
}
.planning .steps .results .results-information {
  border-radius: 8px;
  padding-bottom: 8px;
  background-color: #fff;
  border: 1px solid #e0e5eb;
  box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.08);
}
.planning .steps .results .results-information__data {
  padding-left: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
  min-height: 56px;
  border-bottom: 1px solid #e0e5eb;
  margin-bottom: 0 !important;
}
.planning .steps .results .results-information__info {
  width: 50%;
  display: flex;
  align-items: center;
  word-wrap: break-word;
}
.planning .steps .results .results-information__value {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
.planning .steps .results .results-information__value.highlighted {
  min-height: 56px;
  background-color: #cfe2fc;
  padding: 4px 8px;
}
.planning .steps .results .message-observation {
  text-align: end;
}
.planning .steps .results .message-observation p {
  padding-top: 5px;
}
.planning .steps .results .second-tip-block h6 {
  font-size: 20px;
  font-weight: 900;
}
.planning .steps .results .bar {
  border-bottom: 1px solid #e0e5eb;
  margin: 24px 0;
}
.planning .steps .results .title {
  padding: 24px 0 8px;
}
.planning .steps .results .title.square-title {
  padding: 0;
  padding-bottom: 16px;
}
.planning .steps .results .form .projected-flow {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  background-color: #fff;
  border: 1px dashed #40bbff;
  border-radius: 4px;
  margin-top: 2px;
}
.planning .steps .results .form .projected-flow p {
  font-size: 13px;
  padding-bottom: 16px;
}
.planning .steps .results .form .goal {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  gap: 16.3px;
}
.planning .steps .results .form .goal__input-area .date-picker div[width="16"] {
  z-index: 2;
}
.planning .steps .results .form .goal__input-area .date-picker div[width="16"] > div {
  z-index: 1;
}
.planning .steps .results .form .goal img {
  align-self: flex-start;
  padding-top: 2px;
}
.planning .steps .results .form .goal p {
  padding-bottom: 16px;
}
.planning .steps .results .form .chart-area .wrapper-select {
  display: flex;
  align-items: center;
  gap: 15px;
}
.planning .steps .results .form .chart-area .wrapper-select .btn-clear {
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
  background-color: var(--sebrae-blue);
  color: var(--sebrae-white);
  padding: 5px 10px;
  border-radius: 5px;
  margin-top: 12px;
  width: 100px;
}
.planning .steps .results .form .chart-area__data {
  padding: 30px 0;
}
.planning .steps .results .form .chart-area div[width="286"] {
  z-index: 2;
}
.planning .steps .results .form .chart-area div input {
  width: 100%;
}
.planning .steps .results .form .submit-and-download {
  display: flex;
  justify-content: center;
  padding: 24px 20px;
}
.planning .steps .results .form .technical-notes {
  display: flex;
  cursor: pointer;
  max-width: 103px;
  text-decoration: underline;
}
.planning .steps .results .form .technical-notes:hover {
  color: #000;
}
.planning .steps .results .form .technical-notes:hover p {
  color: #000;
}
.planning .steps .results .form textarea {
  min-height: 148px;
}
.planning .steps .results .finish-and-download {
  display: flex;
}
@media screen and (min-width: 768px) {
  .planning .steps .results {
    padding-bottom: 40px;
  }
  .planning .steps .results .form .submit-and-download {
    display: none;
  }
  .planning .steps .results .form .technical-notes {
    padding: 24px 0;
  }
}
@media screen and (min-width: 992px) {
  .planning .steps .results .results-information {
    padding-bottom: 0;
  }
  .planning .steps .results .results-information__info {
    width: 70%;
  }
  .planning .steps .results .results-information__value {
    width: 30%;
    text-align: center;
  }
  .planning .steps .results .form .goal {
    justify-content: flex-start;
  }
}
@media screen and (min-width: 1024px) {
  .planning .steps .results .form .chart-area__data {
    padding: 30px 0px;
  }
}
.planning .steps .cash-flow {
  padding-bottom: 30px;
}
.planning .steps .cash-flow .wrapper-flux {
  min-width: 250px;
}
.planning .steps .cash-flow .wrapper-flux .default, .planning .steps .cash-flow .wrapper-flux .card-flux, .planning .steps .cash-flow .wrapper-flux h3, .planning .steps .cash-flow .wrapper-flux .date {
  padding: 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  margin-bottom: 16px;
  justify-content: space-between;
  font-size: 15px;
}
.planning .steps .cash-flow .wrapper-flux .date {
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-gray-2);
  background: #e2e6e8;
  height: 40px;
  color: #243342;
  font-style: normal;
  font-weight: 400;
  line-height: 23.3px;
}
.planning .steps .cash-flow .wrapper-flux .date.not-menu {
  background-color: transparent;
  box-shadow: none;
  border: 0;
  opacity: 0;
}
.planning .steps .cash-flow .wrapper-flux h3 {
  border-radius: 12px;
  background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  height: 48px;
  color: var(--sebrae-white);
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
}
.planning .steps .cash-flow .wrapper-flux h3.gradient {
  background: var(--sebrae-white);
  color: #243342;
}
.planning .steps .cash-flow .wrapper-flux .exits .card-flux:first-of-type {
  padding: 10px 15px;
  min-height: 48px;
}
.planning .steps .cash-flow .wrapper-flux .exits .empty {
  background: transparent;
  box-shadow: none;
}
.planning .steps .cash-flow .wrapper-flux .exits .empty p {
  visibility: hidden;
}
.planning .steps .cash-flow .wrapper-flux .exits .content {
  width: 100%;
}
.planning .steps .cash-flow .wrapper-flux .wrapper-card .card-flux {
  margin-bottom: 0;
  padding: 10px 15px;
}
.planning .steps .cash-flow .wrapper-flux .wrapper-card .card-flux:first-child {
  margin-bottom: 14px;
}
.planning .steps .cash-flow .wrapper-flux .wrapper-card .card-flux:last-child {
  margin-bottom: 15px;
}
.planning .steps .cash-flow .wrapper-flux .wrapper-card .card-flux p {
  padding: 0;
}
.planning .steps .cash-flow .wrapper-flux .card-flux {
  border-radius: 12px;
  background: var(--sebrae-white);
  color: #243342;
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
  width: 100%;
  align-items: center;
  min-height: 56px;
}
.planning .steps .cash-flow .wrapper-flux .card-flux-gray {
  background: var(--sebrae-light-gray-2);
  color: #8b99a7;
}
.planning .steps .cash-flow .wrapper-flux .card-flux-gray.active {
  background-color: #cfe2fc;
  color: #005eb8;
}
.planning .steps .cash-flow .wrapper-flux .card-flux .title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 35px;
  align-items: center;
  margin-bottom: 18px;
}
.planning .steps .cash-flow .wrapper-flux .card-flux .title-values {
  width: 100%;
}
.planning .steps .cash-flow .wrapper-flux .card-flux .title-exits {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.planning .steps .cash-flow .wrapper-flux .card-flux .title-exits p {
  margin: 0;
}
.planning .steps .cash-flow .wrapper-flux .card-flux .title-exits:last-of-type p {
  padding: 0;
}
.planning .steps .cash-flow .wrapper-flux .card-flux p {
  color: #617385;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.3px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.planning .steps .cash-flow .wrapper-flux .card-flux p:last-child {
  padding: 0;
}
.planning .steps .cash-flow .wrapper-flux .card-flux .arrow {
  border: 1px solid #617385;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.planning .steps .cash-flow .wrapper-flux .card-flux.small {
  padding: 8px 15px;
  min-height: 40px;
  margin-bottom: 0 !important;
}
.planning .steps .cash-flow .wrapper-flux .card-flux.balance {
  flex-direction: column;
}
.planning .steps .cash-flow .wrapper-flux .card-flux.balance .header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.planning .steps .cash-flow .wrapper-flux .card-flux.balance .has-balance {
  width: 100%;
  margin-top: 5px;
}
.planning .steps .cash-flow .wrapper-flux .card-flux.balance p {
  padding: 0;
  margin: 0 0 2px;
  font-size: 13px;
  line-height: 1.3;
  color: #617385;
}
.planning .steps .cash-flow .wrapper-flux .card-flux.balance.has-balance {
  min-height: 100px;
}
.planning .steps .cash-flow .wrapper-flux .card-flux.balance.small {
  min-height: 56px;
  margin-bottom: 60px !important;
  justify-content: center;
  align-items: start;
}
.planning .steps .cash-flow .wrapper-flux.title {
  min-width: 100%;
}
.planning .steps .cash-flow .wrapper-flux.dynamic .exits .card-flux {
  margin-bottom: 8px;
}
.planning .steps .cash-flow .SettingsSliderCashFlow.slick-slider {
  margin: 0 -16px !important;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-track {
  display: flex !important;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-slide {
  height: inherit !important;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-slide div:first-child {
  height: 100%;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-list .wrapper-flux {
  padding-left: 15px;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-dots {
  position: relative;
  bottom: 0;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-dots li {
  width: 18px;
  height: 10px;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-dots li button {
  background-color: #005eb8;
  border-radius: 50%;
  opacity: 1;
  width: 10px;
  height: 10px;
  transition: 0.3s;
  font-size: 1px;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-dots li button:before {
  content: none;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .slick-dots li.slick-active button {
  border-radius: 66.667px;
  width: 18px;
}
@media (min-width: 767px) {
  .planning .steps .cash-flow .SettingsSliderCashFlow .slick-list {
    overflow: visible;
  }
}
.planning .steps .cash-flow .SettingsSliderCashFlow .wrapper-flux {
  position: relative;
  height: 100%;
  padding-bottom: 72px;
}
.planning .steps .cash-flow .SettingsSliderCashFlow .wrapper-flux .capacity {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  width: calc(100% - 15px);
  margin: 0 0 0 auto;
  padding: 10px 16px;
}
.planning .steps .cash-flow .SettingsSliderCashFlow.empty .wrapper-flux {
  padding-left: 0;
}
.planning .steps .cash-flow .SettingsSliderCashFlow.empty .wrapper-flux .capacity {
  width: 100%;
}
.planning .steps .cash-flow .label-installments {
  padding: 10px 0;
  border-top: 1px solid #e0e5eb;
  margin-top: 16px;
}
.planning .steps .cash-flow .form-date .description {
  font-weight: 600;
}
.planning .steps .cash-flow .form-date .description span {
  color: #243342;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.3px;
  display: block;
  padding-top: 16px;
}
.planning .steps .cash-flow .form-date label {
  color: #617385 !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 5px;
}
.planning .steps .cash-flow .form-initial-values .description {
  font-weight: 500;
  padding-bottom: 16px;
}
.planning .steps .cash-flow .form-initial-values .wrapper-date {
  max-width: 50%;
  margin-bottom: 16px;
}
.planning .steps .cash-flow .form-initial-values label {
  color: #617385 !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 5px;
}
.planning .steps .cash-flow .date .currency {
  padding: 10px 0 0;
}
.planning .steps .cash-flow .date .wrapper-date {
  display: flex;
  gap: 20px;
}
.planning .steps .cash-flow .date .wrapper-date > div {
  width: 100%;
}
.planning .steps .cash-flow .BaSe--checkbox div:last-child {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  width: 18px;
  height: 18px;
}
.planning .steps .cash-flow .additional-month {
  max-height: 400px;
  overflow: auto;
  padding-right: 15px;
  margin-right: -10px;
  margin-top: 15px;
}
.planning .steps .cash-flow .wrapper-button {
  padding: 20px 0 10px;
  text-align: right;
}
.planning .steps .cash-flow .wrapper-button button {
  background-color: var(--sebrae-blue);
  color: var(--sebrae-white);
  border-radius: 4px;
  height: 40px;
  padding: 0 15px;
}
.planning .steps .cash-flow button:disabled {
  opacity: 0.7;
  cursor: no-drop;
}
@media (min-width: 767px) {
  .planning .steps .cash-flow .wrapper-flux {
    min-width: 286px;
  }
  .planning .steps .cash-flow .additional-month {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 16px;
  }
  .planning .steps .cash-flow .wrapper-button {
    text-align: left;
  }
}
.planning__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 16px;
  width: 100%;
  z-index: 2;
  background-color: var(--sebrae-white-2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}
.planning__footer.start {
  justify-content: flex-end;
}
@media screen and (min-width: 560px) {
  .planning__footer {
    padding-left: 86px;
  }
}
.planning .group-input {
  border-bottom: 1px solid var(--sebrae-light-gray-2);
}
.planning .group-input.desktop {
  border: none;
}
@media screen and (min-width: 1280px) {
  .planning .group-input.desktop {
    border-bottom: 1px solid var(--sebrae-light-gray-2);
  }
  .planning .group-input.mobile {
    border: none;
  }
}
.planning .fampe-range .custom-input-range .input-range .input-range__wrapper-input::-webkit-slider-runnable-track {
  background: green;
}
.planning .BaSe--grid {
  gap: 16px;
}
.planning .finish-and-download {
  display: none;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto 8px;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 48px;
  border-radius: 4px;
  gap: 8px;
}
.planning .finish-and-download p {
  color: var(--sebrae-white);
  margin: 0;
}
.planning .finish-and-download.disabled {
  border: none;
  background: #b6bfc8;
  cursor: not-allowed;
}
.planning .finish-and-download.finish {
  border: none;
  background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);
}
.planning .finish-and-download.download {
  border: 2px solid #e0e5eb;
  background: #f5f7fa;
}
.planning .finish-and-download.download p {
  color: #243342;
}
@media screen and (min-width: 768px) {
  .planning .steps {
    display: flex;
    min-height: 100vh;
    padding: 0;
  }
  .planning .steps .steps__header {
    position: relative;
    width: 100%;
    max-width: 326px;
    padding: 60px 16px 24px;
    background: var(--sebrae-light-gray-2);
  }
  .planning .steps .steps__header .content_header {
    position: fixed;
    max-width: 294px;
    width: 100%;
  }
  .planning .steps .steps__header ul li {
    height: 48px;
    margin-bottom: 8px;
    border-radius: 4px;
  }
  .planning .steps .steps__header ul li p {
    font-size: 16px;
    visibility: visible;
  }
  .planning .steps .steps__header ul li:nth-child(1) {
    background-color: #994599 !important;
    border-color: #994599 !important;
    color: #994599 !important;
  }
  .planning .steps .steps__header ul li:nth-child(1).is-completed {
    background-color: transparent !important;
    border-color: #994599 !important;
    color: #994599 !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(1).active {
    background-color: #994599 !important;
    border-color: #994599 !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(2) {
    background-color: #5c8fd6 !important;
    border-color: #5c8fd6 !important;
    color: #5c8fd6 !important;
  }
  .planning .steps .steps__header ul li:nth-child(2).is-completed {
    background-color: transparent !important;
    border-color: #5c8fd6 !important;
    color: #5c8fd6 !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(2).active {
    background-color: #5c8fd6 !important;
    border-color: #5c8fd6 !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(3) {
    background-color: #005eb8 !important;
    border-color: #005eb8 !important;
    color: #005eb8 !important;
  }
  .planning .steps .steps__header ul li:nth-child(3).is-completed {
    background-color: transparent !important;
    border-color: #005eb8 !important;
    color: #005eb8 !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(3).active {
    background-color: #005eb8 !important;
    border-color: #005eb8 !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(4) {
    background-color: #0f438a !important;
    border-color: #0f438a !important;
    color: #0f438a !important;
  }
  .planning .steps .steps__header ul li:nth-child(4).is-completed {
    background-color: transparent !important;
    border-color: #0f438a !important;
    color: #0f438a !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(4).active {
    background-color: #0f438a !important;
    border-color: #0f438a !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(5) {
    background-color: #0024a9 !important;
    border-color: #0024a9 !important;
    color: #0024a9 !important;
  }
  .planning .steps .steps__header ul li:nth-child(5).is-completed {
    background-color: transparent !important;
    border-color: #0024a9 !important;
    color: #0024a9 !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(5).active {
    background-color: #0024a9 !important;
    border-color: #0024a9 !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(6) {
    background-color: #142e52 !important;
    border-color: #142e52 !important;
    color: #142e52 !important;
  }
  .planning .steps .steps__header ul li:nth-child(6).is-completed {
    background-color: transparent !important;
    border-color: #142e52 !important;
    color: #142e52 !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(6).active {
    background-color: #142e52 !important;
    border-color: #142e52 !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(7) {
    background-color: #0a1729 !important;
    border-color: #0a1729 !important;
    color: #0a1729 !important;
  }
  .planning .steps .steps__header ul li:nth-child(7).is-completed {
    background-color: transparent !important;
    border-color: #0a1729 !important;
    color: #0a1729 !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(7).active {
    background-color: #0a1729 !important;
    border-color: #0a1729 !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(8) {
    background-color: #14adcc !important;
    border-color: #14adcc !important;
    color: #14adcc !important;
  }
  .planning .steps .steps__header ul li:nth-child(8).is-completed {
    background-color: transparent !important;
    border-color: #14adcc !important;
    color: #14adcc !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(8).active {
    background-color: #14adcc !important;
    border-color: #14adcc !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(9) {
    background-color: #0e778b !important;
    border-color: #0e778b !important;
    color: #0e778b !important;
  }
  .planning .steps .steps__header ul li:nth-child(9).is-completed {
    background-color: transparent !important;
    border-color: #0e778b !important;
    color: #0e778b !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(9).active {
    background-color: #0e778b !important;
    border-color: #0e778b !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li:nth-child(10) {
    background-color: #094f5d !important;
    border-color: #094f5d !important;
    color: #094f5d !important;
  }
  .planning .steps .steps__header ul li:nth-child(10).is-completed {
    background-color: transparent !important;
    border-color: #094f5d !important;
    color: #094f5d !important;
    cursor: pointer;
  }
  .planning .steps .steps__header ul li:nth-child(10).active {
    background-color: #094f5d !important;
    border-color: #094f5d !important;
    color: var(--sebrae-white) !important;
  }
  .planning .steps .steps__header ul li.has-name {
    height: 48px;
  }
  .planning .steps .steps__header ul li:not(.active) {
    background-color: transparent !important;
    border-color: #b6bfc8 !important;
    color: #b6bfc8 !important;
  }
  .planning .steps .steps__body {
    position: relative;
    width: 100%;
    padding: 45px 16px 80px;
    overflow: hidden;
  }
  .planning .steps .step h5 {
    font-size: 23px;
  }
  .planning__footer {
    position: absolute;
    padding: 16px;
  }
  .planning .finish-and-download {
    display: flex !important;
  }
}
@media screen and (min-width: 1366px) {
  .planning .steps .steps__body {
    padding: 15px 100px 24px 16px;
  }
  .planning .steps .steps__body .step {
    margin-top: 30px;
  }
  .planning__footer {
    padding-right: 116px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/planning/index.scss"],"names":[],"mappings":"AAcE;EACE,WAAA;EACA,8BAAA;EACA,oBAAA;AAbJ;AAgBM;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAdR;AAgBQ;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,sCAAA;EACA,0BAAA;EACA,eAAA;AAdV;AAiBY;EACE,yBAvCH;EAwCG,qBAxCH;AAyBX;AAaY;EACE,yBAvCH;EAwCG,qBAxCH;AA6BX;AASY;EACE,yBAvCH;EAwCG,qBAxCH;AAiCX;AAKY;EACE,yBAvCH;EAwCG,qBAxCH;AAqCX;AACY;EACE,yBAvCH;EAwCG,qBAxCH;AAyCX;AAHY;EACE,yBAvCH;EAwCG,qBAxCH;AA6CX;AAPY;EACE,yBAvCH;EAwCG,qBAxCH;AAiDX;AAXY;EACE,yBAvCH;EAwCG,qBAxCH;AAqDX;AAfY;EACE,yBAvCH;EAwCG,qBAxCH;AAyDX;AAnBY;EACE,yBAvCH;EAwCG,qBAxCH;AA6DX;AAjBU;EAEI,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,kBAAA;AAiBZ;AAdU;EACE,iBAAA;EACA,YAAA;AAgBZ;AAdY;EACE,mBAAA;AAgBd;AAbU;EACE,iBAAA;EACA,YAAA;AAeZ;AAbY;EACE,eAAA;EACA,mBAAA;AAed;AATM;EAGM;IACE,YAAA;EASZ;EAPY;IACE,eAAA;IACA,mBAAA;EASd;AACF;AAHI;EACE,eAAA;AAKN;AADM;EACE,cAAA;AAGR;AAEQ;EACE,UAAA;AAAV;AAMM;;EACE,cAAA;AAHR;AAKQ;;EACE,SAAA;AAFV;AAKM;;EACE,WAAA;EACA,cAAA;EACA,iBAAA;AAFR;AAIM;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AADR;AAGQ;;EACE,iCAAA;EACA,eAAA;AAAV;AAEU;;EACE,kBAAA;AACZ;AAKM;EACE,WAAA;EACA,cAAA;EACA,sBAAA;AAHR;AAMQ;EACE,mBAAA;AAJV;AAOQ;EACE,iBAAA;AALV;AAOU;EAHF;IAII,iBAAA;EAJV;AACF;AAOQ;EACE,iBAAA;AALV;AAQM;EACE,gBAAA;AANR;AASQ;EACE,yBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,SAAA;AATV;AAYQ;EACE,iBAAA;AAVV;AAYU;EAHF;IAII,kBAAA;EATV;AACF;AAWU;EAPF;IAQI,kBAAA;EARV;AACF;AAWU;EACE,SAAA;AATZ;AAWY;EACE,kBAAA;EACA,gBAAA;AATd;AAWY;EACE,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,wEAAA;AATd;AAkBU;EACE,SAAA;AAhBZ;AAkBY;EACE,kBAAA;EACA,gBAAA;AAhBd;AAmBY;EACE,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,wEAAA;AAjBd;AAyBQ;EACE,eAAA;AAvBV;AA4BM;EAEI,eAAA;EACA,gBAAA;EAEF,cAAA;EACA,cAAA;EACA,gBAAA;AA5BR;AA8BM;EACE,gBAAA;AA5BR;AA8BQ;;EAEE,gBAAA;EACA,SAAA;AA5BV;AA+BM;EACE,oBAAA;EACA,mBAAA;AA7BR;AA+BQ;EACE;IACE,oBAAA;EA7BV;AACF;AAgCQ;EACE,gBAAA;AA9BV;AAiCQ;EACE,yBAAA;EACA,oCAAA;EACA,oCAAA;AA/BV;AAkCQ;EACE,yBAAA;EACA,oCAAA;EACA,oCAAA;AAhCV;AAmCQ;EACE,yBAAA;EACA,oCAAA;EACA,oCAAA;AAjCV;AAoCM;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;EACA,+BAAA;EACA,6CAAA;EACA,aAAA;EACA,yBAAA;AAlCR;AAoCQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAlCV;AAoCQ;EACE,cAAA;EACA,0BAAA;AAlCV;AAsCM;EACE;IACE,yBAAA;EApCR;EAsCM;IACE,gBAAA;EApCR;AACF;AAsCM;EACE;IACE,WAAA;EApCR;EAsCQ;IACE,eAAA;EApCV;EAsCQ;;IAEE,gBAAA;EApCV;EAuCM;IACE,gBAAA;IACA,kBAAA;EArCR;AACF;AAwCI;EACE,gBAAA;AAtCN;AAyCQ;EACE,iBAAA;AAvCV;AA0CM;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,6CAAA;AAxCR;AA0CQ;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EAEA,8BAAA;EACA,gBAAA;EACA,gCAAA;EACA,2BAAA;AAzCV;AA4CQ;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AA1CV;AA6CQ;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AA3CV;AA6CU;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;AA3CZ;AA+CM;EACE,eAAA;AA7CR;AA+CQ;EACE,gBAAA;AA7CV;AAiDQ;EACE,eAAA;EACA,gBAAA;AA/CV;AAmDM;EACE,gCAAA;EACA,cAAA;AAjDR;AAmDM;EACE,mBAAA;AAjDR;AAmDQ;EACE,UAAA;EACA,oBAAA;AAjDV;AAqDQ;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AAnDV;AAqDU;EACE,eAAA;EACA,oBAAA;AAnDZ;AAuDQ;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,WAAA;AArDV;AAyDc;EACE,UAAA;AAvDhB;AAyDgB;EACE,UAAA;AAvDlB;AA6DU;EACE,sBAAA;EACA,gBAAA;AA3DZ;AA8DU;EACE,oBAAA;AA5DZ;AAiEU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA/DZ;AAiEY;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AA/Dd;AAkEU;EACE,eAAA;AAhEZ;AAmEU;EACE,UAAA;AAjEZ;AAqEY;EACE,WAAA;AAnEd;AAwEQ;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAtEV;AAyEQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAvEV;AAyEU;EACE,WAAA;AAvEZ;AAwEY;EACE,WAAA;AAtEd;AA2EQ;EACE,iBAAA;AAzEV;AA4EM;EACE,aAAA;AA1ER;AA6EM;EAvLF;IAwLI,oBAAA;EA1EN;EA6EQ;IACE,aAAA;EA3EV;EA8EQ;IACE,eAAA;EA5EV;AACF;AA+EM;EACE;IACE,iBAAA;EA7ER;EA+EQ;IACE,UAAA;EA7EV;EAgFQ;IACE,UAAA;IACA,kBAAA;EA9EV;EAmFQ;IACE,2BAAA;EAjFV;AACF;AAoFM;EAGM;IACE,iBAAA;EApFZ;AACF;AAyFI;EACE,oBAAA;AAvFN;AAyFM;EACE,gBAAA;AAvFR;AAyFQ;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAvFV;AAyFQ;EACE,kBAAA;EACA,4CAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvFV;AA0FU;EACE,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAxFZ;AA2FQ;EACE,mBAAA;EACA,4DAAA;EACA,6CAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAzFV;AA4FU;EACE,+BAAA;EACA,cAAA;AA1FZ;AA+FY;EACE,kBAAA;EACA,gBAAA;AA7Fd;AAgGU;EACE,uBAAA;EACA,gBAAA;AA9FZ;AA+FY;EACE,kBAAA;AA7Fd;AAgGU;EACE,WAAA;AA9FZ;AAkGU;EACE,gBAAA;EACA,kBAAA;AAhGZ;AAkGY;EACE,mBAAA;AAhGd;AAkGY;EACE,mBAAA;AAhGd;AAkGY;EACE,UAAA;AAhGd;AAoGQ;EACE,mBAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAlGV;AAqGU;EACE,sCAAA;EACA,cAAA;AAnGZ;AAqGY;EACE,yBAAA;EACA,cAAA;AAnGd;AAuGU;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AArGZ;AAuGY;EACE,WAAA;AArGd;AAwGU;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AAtGZ;AAwGY;EACE,SAAA;AAtGd;AA0Gc;EACE,UAAA;AAxGhB;AA6GU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;AA3GZ;AA6GY;EACE,UAAA;AA3Gd;AA+GU;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7GZ;AAgHU;EACE,iBAAA;EACA,gBAAA;EACA,2BAAA;AA9GZ;AAgHU;EACE,sBAAA;AA9GZ;AAgHY;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA9Gd;AAgHY;EACE,WAAA;EACA,eAAA;AA9Gd;AAgHY;EACE,UAAA;EACA,eAAA;EAEE,eAAA;EAEF,gBAAA;EACA,cAAA;AAhHd;AAmHY;EACE,iBAAA;AAjHd;AAmHY;EACE,gBAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AAjHd;AAqHQ;EACE,eAAA;AAnHV;AAuHY;EACE,kBAAA;AArHd;AA4HQ;EACE,0BAAA;AA1HV;AA4HQ;EACE,wBAAA;AA1HV;AA4HQ;EACE,0BAAA;AA1HV;AA4HU;EACE,YAAA;AA1HZ;AA+HY;EACE,kBAAA;AA7Hd;AAiIU;EACE,kBAAA;EACA,SAAA;AA/HZ;AAiIY;EACE,WAAA;EACA,YAAA;AA/Hd;AAgIc;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AA9HhB;AAgIgB;EACE,aAAA;AA9HlB;AAkIgB;EACE,uBAAA;EACA,WAAA;AAhIlB;AAsIU;EACE;IACE,iBAAA;EApIZ;AACF;AAuIQ;EACE,kBAAA;EACA,YAAA;EACA,oBAAA;AArIV;AAuIU;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;AArIZ;AAyIU;EACE,eAAA;AAvIZ;AAyIY;EACE,WAAA;AAvId;AA6IM;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;AA3IR;AAgJU;EACE,gBAAA;AA9IZ;AA+IY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AA7Id;AAgJU;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA9IZ;AAmJU;EACE,gBAAA;EACA,oBAAA;AAjJZ;AAoJU;EACE,cAAA;EACA,mBAAA;AAlJZ;AAqJU;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAnJZ;AAyJQ;EACE,iBAAA;AAvJV;AA0JQ;EACE,aAAA;EACA,SAAA;AAxJV;AA0JU;EACE,WAAA;AAxJZ;AA+JU;EACE,wCAAA;EACA,WAAA;EACA,YAAA;AA7JZ;AAkKM;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAhKR;AAmKM;EACE,oBAAA;EACA,iBAAA;AAjKR;AAmKQ;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAjKV;AAsKQ;EACE,YAAA;EACA,eAAA;AApKV;AAwKM;EACE;IACE,gBAAA;EAtKR;EAwKM;IACE,aAAA;IACA,8BAAA;IACA,WAAA;EAtKR;EAwKM;IACE,gBAAA;EAtKR;AACF;AA0KE;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,uCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAxKJ;AA0KI;EACE,yBAAA;AAxKN;AA2KI;EAjBF;IAkBI,kBAAA;EAxKJ;AACF;AA0KE;EACE,mDAAA;AAxKJ;AAyKI;EACE,YAAA;AAvKN;AA0KI;EACE;IACE,mDAAA;EAxKN;EA0KI;IACE,YAAA;EAxKN;AACF;AA+KU;EACE,iBAAA;AA7KZ;AAmLE;EACE,SAAA;AAjLJ;AAmLE;EACE,aAAA;EAEA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EAEA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AAnLJ;AAqLI;EACE,0BAAA;EACA,SAAA;AAnLN;AAsLI;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;AApLN;AAsLI;EACE,YAAA;EACA,4DAAA;AApLN;AAsLI;EACE,yBAAA;EACA,mBAAA;AApLN;AAsLM;EACE,cAAA;AApLR;AAyLE;EACE;IACE,aAAA;IACA,iBAAA;IACA,UAAA;EAvLJ;EAyLI;IACE,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,sCAAA;EAvLN;EAyLM;IACE,eAAA;IACA,gBAAA;IACA,WAAA;EAvLR;EA2LQ;IACE,YAAA;IACA,kBAAA;IACA,kBAAA;EAzLV;EA2LU;IACE,eAAA;IACA,mBAAA;EAzLZ;EA6LY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Ld;EA6Lc;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3LhB;EA6Lc;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3LhB;EA6KY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Kd;EA6Kc;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3KhB;EA6Kc;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3KhB;EA6JY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Jd;EA6Jc;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3JhB;EA6Jc;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3JhB;EA6IY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Id;EA6Ic;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3IhB;EA6Ic;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3IhB;EA6HY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Hd;EA6Hc;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3HhB;EA6Hc;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3HhB;EA6GY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Gd;EA6Gc;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3GhB;EA6Gc;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3GhB;EA6FY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Fd;EA6Fc;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3FhB;EA6Fc;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3FhB;EA6EY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Ed;EA6Ec;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3EhB;EA6Ec;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3EhB;EA6DY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Dd;EA6Dc;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3DhB;EA6Dc;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3DhB;EA6CY;IACE,oCAAA;IACA,gCAAA;IACA,yBAAA;EA3Cd;EA6Cc;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;IACA,eAAA;EA3ChB;EA6Cc;IACE,oCAAA;IACA,gCAAA;IACA,qCAAA;EA3ChB;EA+CU;IACE,YAAA;EA7CZ;EAgDQ;IACE,wCAAA;IACA,gCAAA;IACA,yBAAA;EA9CV;EAkDI;IACE,kBAAA;IACA,WAAA;IACA,uBAAA;IACA,gBAAA;EAhDN;EAmDM;IACE,eAAA;EAjDR;EAqDE;IACE,kBAAA;IACA,aAAA;EAnDJ;EAqDE;IACE,wBAAA;EAnDJ;AACF;AAqDE;EAEI;IACE,6BAAA;EApDN;EAsDM;IACE,gBAAA;EApDR;EAwDE;IACE,oBAAA;EAtDJ;AACF","sourcesContent":[".planning {\n  $colors: (\n    \"1\": #994599,\n    \"2\": #5c8fd6,\n    \"3\": #005eb8,\n    \"4\": #0f438a,\n    \"5\": #0024a9,\n    \"6\": #142e52,\n    \"7\": #0a1729,\n    \"8\": #14adcc,\n    \"9\": #0e778b,\n    \"10\": #094f5d,\n  );\n\n  .steps {\n    width: 100%;\n    min-height: calc(100vh - 56px);\n    padding-bottom: 70px;\n\n    &__header {\n      ul {\n        width: 100%;\n        list-style: none;\n        margin: 0;\n        padding: 0;\n\n        li {\n          width: 100%;\n          height: 8px;\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n          transition: all 0.2s ease-in-out;\n          border: 1px solid #b6bfc8;\n          background-color: var(--sebrae-purple);\n          color: var(--sebrae-white);\n          padding: 0 16px;\n\n          @each $idx, $color in $colors {\n            &:nth-child(#{$idx}) {\n              background-color: $color;\n              border-color: $color;\n            }\n          }\n\n          p {\n            font: {\n              family: var(--font-lato);\n              size: 13px;\n              weight: 700;\n            }\n            visibility: hidden;\n          }\n\n          &.has-name {\n            padding: 8px 16px;\n            height: 32px;\n\n            p {\n              visibility: visible;\n            }\n          }\n          &.active {\n            padding: 8px 16px;\n            height: 55px;\n\n            p {\n              font-size: 17px;\n              visibility: visible;\n            }\n          }\n        }\n      }\n\n      @media screen and (max-width: 767px) {\n        &.expanded {\n          ul {\n            li {\n              height: 33px;\n\n              p {\n                font-size: 13px;\n                visibility: visible;\n              }\n            }\n          }\n        }\n      }\n    }\n    &__body {\n      padding: 16px 0;\n    }\n\n    .step {\n      h5 {\n        margin: 16px 0;\n      }\n    }\n    .total-investment {\n      .BaSe--input {\n        .BaSe--input-wrapper {\n          width: 50%;\n        }\n      }\n    }\n    .receipt-deadline,\n    .payment-terms {\n      .installments {\n        margin: 15px 0;\n\n        .custom-input-range {\n          margin: 0;\n        }\n      }\n      .btn-add-more {\n        width: 24px;\n        display: block;\n        margin: 24px auto;\n      }\n      .wrapper-button-secondary {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: 15px auto;\n\n        button {\n          border-color: var(--sebrae-white);\n          font-size: 13px;\n\n          span {\n            font-size: inherit;\n          }\n        }\n      }\n    }\n    .inventory-turnover {\n      .btn-add-more {\n        width: 24px;\n        display: block;\n        margin: 10px auto 16px;\n      }\n      .grid-buttons-area {\n        div {\n          align-items: center;\n        }\n\n        .top-input {\n          padding-left: 4px;\n\n          @media (max-width: 320px) {\n            padding-left: 8px;\n          }\n        }\n\n        .remove-button {\n          padding-top: 17px;\n        }\n      }\n      form {\n        max-width: 389px;\n      }\n      .result {\n        p {\n          color: var(--sebrae-blue);\n          font: {\n            size: 11px;\n            weight: 400;\n          }\n          margin: 0;\n        }\n\n        input {\n          margin-right: 6px;\n\n          @media (max-width: 380px) {\n            margin-right: 10px;\n          }\n\n          @media (max-width: 320px) {\n            margin-right: 13px;\n          }\n        }\n        .input-100 {\n          .BaSe--input {\n            margin: 0;\n\n            .BaSe--input-wrapper {\n              border-radius: 4px;\n              overflow: hidden;\n            }\n            input {\n              background: var(--sebrae-white);\n              border-radius: 4px;\n              border-width: 2px;\n              border-image-slice: 1;\n              border-image-source: linear-gradient(\n                to right,\n                #3b4aff 0%,\n                #40bbff 100%\n              );\n            }\n          }\n        }\n        .input-not-100 {\n          .BaSe--input {\n            margin: 0;\n\n            .BaSe--input-wrapper {\n              border-radius: 4px;\n              overflow: hidden;\n            }\n\n            input {\n              background: var(--sebrae-white);\n              border-radius: 4px;\n              border-width: 2px;\n              border-image-slice: 1;\n              border-image-source: linear-gradient(\n                to right,\n                #ff3b3b 0%,\n                #760303 100%\n              );\n            }\n          }\n        }\n        .BaSe--grid-item:first-of-type {\n          align-self: end;\n        }\n      }\n    }\n    .guarantees {\n      p {\n        font: {\n          size: 13px;\n          weight: 400;\n        }\n        color: #181a1b;\n        margin: 15px 0;\n        max-width: 493px;\n      }\n      form {\n        max-width: 596px;\n\n        .BaSe--grid,\n        .wrapper-select {\n          max-width: 252px;\n          margin: 0;\n        }\n      }\n      .group-input {\n        padding-bottom: 15px;\n        margin-bottom: 15px;\n\n        @media (min-width: 1280px) {\n          &.gi-space {\n            padding-bottom: 60px;\n          }\n        }\n\n        .BaSe--input {\n          margin-bottom: 0;\n        }\n\n        #greenStatus {\n          color: #00662a !important;\n          background-color: #c2efd1 !important;\n          border: 1px solid #85e0a3 !important;\n        }\n\n        #redStatus {\n          color: #bf303c !important;\n          background-color: #f3d8da !important;\n          border: 1px solid #bf303c !important;\n        }\n\n        #yellowStatus {\n          color: #664d1a !important;\n          background-color: #ffeecc !important;\n          border: 1px solid #ffbf40 !important;\n        }\n      }\n      .box-fampe {\n        width: 100%;\n        max-width: 252px;\n        border-radius: 8px;\n        border: 1px solid var(--sebrae-light-gray-2);\n        background: var(--sebrae-white);\n        box-shadow: 0 4px 8px 0 rgba(20, 46, 82, 0.2);\n        padding: 16px;\n        color: var(--sebrae-blue);\n\n        p {\n          font-size: 16px;\n          margin: 0 0 16px;\n          color: inherit;\n        }\n        a {\n          color: inherit;\n          text-decoration: underline;\n        }\n      }\n\n      @media screen and (min-width: 768px) {\n        .planning__footer {\n          justify-content: baseline;\n        }\n        .BaSe--grid {\n          position: static;\n        }\n      }\n      @media screen and (min-width: 1280px) {\n        form {\n          width: 100%;\n\n          .BaSe--grid {\n            max-width: 100%;\n          }\n          .wrapper-select,\n          .BaSe--input {\n            max-width: 286px;\n          }\n        }\n        .box-fampe {\n          max-width: 286px;\n          margin: 0 0 0 auto;\n        }\n      }\n    }\n    .results {\n      max-width: 612px;\n\n      .notes-modal {\n        span {\n          font-weight: bold;\n        }\n      }\n      .results-information {\n        border-radius: 8px;\n        padding-bottom: 8px;\n        background-color: #fff;\n        border: 1px solid #e0e5eb;\n        box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.08);\n\n        &__data {\n          padding-left: 16px;\n          display: flex;\n          flex-wrap: wrap;\n          align-items: stretch;\n          // align-items: center;\n          justify-content: space-between;\n          min-height: 56px;\n          border-bottom: 1px solid #e0e5eb;\n          margin-bottom: 0 !important;\n        }\n\n        &__info {\n          width: 50%;\n          display: flex;\n          align-items: center;\n          word-wrap: break-word;\n        }\n\n        &__value {\n          width: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background-color: transparent;\n\n          &.highlighted {\n            min-height: 56px;\n            background-color: #cfe2fc;\n            padding: 4px 8px;\n          }\n        }\n      }\n      .message-observation {\n        text-align: end;\n\n        p {\n          padding-top: 5px;\n        }\n      }\n      .second-tip-block {\n        h6 {\n          font-size: 20px;\n          font-weight: 900;\n        }\n      }\n\n      .bar {\n        border-bottom: 1px solid #e0e5eb;\n        margin: 24px 0;\n      }\n      .title {\n        padding: 24px 0 8px;\n\n        &.square-title {\n          padding: 0;\n          padding-bottom: 16px;\n        }\n      }\n      .form {\n        .projected-flow {\n          display: flex;\n          align-items: center;\n          flex-direction: column;\n          justify-content: center;\n          padding: 16px;\n          background-color: #fff;\n          border: 1px dashed #40bbff;\n          border-radius: 4px;\n          margin-top: 2px;\n\n          p {\n            font-size: 13px;\n            padding-bottom: 16px;\n          }\n        }\n\n        .goal {\n          padding: 16px;\n          display: flex;\n          justify-content: space-between;\n          background-color: #fff;\n          gap: 16.3px;\n\n          &__input-area {\n            .date-picker {\n              div[width=\"16\"] {\n                z-index: 2;\n\n                & > div {\n                  z-index: 1;\n                }\n              }\n            }\n          }\n\n          img {\n            align-self: flex-start;\n            padding-top: 2px;\n          }\n\n          p {\n            padding-bottom: 16px;\n          }\n        }\n\n        .chart-area {\n          .wrapper-select {\n            display: flex;\n            align-items: center;\n            gap: 15px;\n\n            .btn-clear {\n              font-size: 12px;\n              font-style: normal;\n              font-weight: 700;\n              line-height: 23.3px;\n              background-color: var(--sebrae-blue);\n              color: var(--sebrae-white);\n              padding: 5px 10px;\n              border-radius: 5px;\n              margin-top: 12px;\n              width: 100px;\n            }\n          }\n          &__data {\n            padding: 30px 0;\n          }\n\n          div[width=\"286\"] {\n            z-index: 2;\n          }\n\n          div {\n            input {\n              width: 100%;\n            }\n          }\n        }\n\n        .submit-and-download {\n          display: flex;\n          justify-content: center;\n          padding: 24px 20px;\n        }\n\n        .technical-notes {\n          display: flex;\n          cursor: pointer;\n          max-width: 103px;\n          text-decoration: underline;\n\n          &:hover {\n            color: #000;\n            p {\n              color: #000;\n            }\n          }\n        }\n\n        textarea {\n          min-height: 148px;\n        }\n      }\n      .finish-and-download {\n        display: flex;\n      }\n\n      @media screen and (min-width: 768px) {\n        padding-bottom: 40px;\n\n        .form {\n          .submit-and-download {\n            display: none;\n          }\n\n          .technical-notes {\n            padding: 24px 0;\n          }\n        }\n      }\n      @media screen and (min-width: 992px) {\n        .results-information {\n          padding-bottom: 0;\n\n          &__info {\n            width: 70%;\n          }\n\n          &__value {\n            width: 30%;\n            text-align: center;\n          }\n        }\n\n        .form {\n          .goal {\n            justify-content: flex-start;\n          }\n        }\n      }\n      @media screen and (min-width: 1024px) {\n        .form {\n          .chart-area {\n            &__data {\n              padding: 30px 0px;\n            }\n          }\n        }\n      }\n    }\n    .cash-flow {\n      padding-bottom: 30px;\n\n      .wrapper-flux {\n        min-width: 250px;\n\n        .default {\n          padding: 16px;\n          display: flex;\n          align-items: center;\n          box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n          margin-bottom: 16px;\n          justify-content: space-between;\n          font-size: 15px;\n        }\n        .date {\n          border-radius: 4px;\n          border: 1px solid var(--sebrae-light-gray-2);\n          background: #e2e6e8;\n          height: 40px;\n          color: #243342;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 23.3px;\n          @extend .default;\n\n          &.not-menu {\n            background-color: transparent;\n            box-shadow: none;\n            border: 0;\n            opacity: 0;\n          }\n        }\n        h3 {\n          border-radius: 12px;\n          background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);\n          box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n          height: 48px;\n          color: var(--sebrae-white);\n          font-style: normal;\n          font-weight: 700;\n          line-height: 23.3px;\n          @extend .default;\n\n          &.gradient {\n            background: var(--sebrae-white);\n            color: #243342;\n          }\n        }\n        .exits {\n          .card-flux {\n            &:first-of-type {\n              padding: 10px 15px;\n              min-height: 48px;\n            }\n          }\n          .empty {\n            background: transparent;\n            box-shadow: none;\n            p {\n              visibility: hidden;\n            }\n          }\n          .content {\n            width: 100%;\n          }\n        }\n        .wrapper-card {\n          .card-flux {\n            margin-bottom: 0;\n            padding: 10px 15px;\n\n            &:first-child {\n              margin-bottom: 14px;\n            }\n            &:last-child {\n              margin-bottom: 15px;\n            }\n            p {\n              padding: 0;\n            }\n          }\n        }\n        .card-flux {\n          border-radius: 12px;\n          background: var(--sebrae-white);\n          color: #243342;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 23.3px;\n          width: 100%;\n          align-items: center;\n          min-height: 56px;\n          @extend .default;\n\n          &-gray {\n            background: var(--sebrae-light-gray-2);\n            color: #8b99a7;\n\n            &.active {\n              background-color: #cfe2fc;\n              color: #005eb8;\n            }\n          }\n\n          .title {\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n            min-height: 35px;\n            align-items: center;\n            margin-bottom: 18px;\n\n            &-values {\n              width: 100%;\n            }\n          }\n          .title-exits {\n            width: 100%;\n            display: flex;\n            justify-content: space-between;\n\n            p {\n              margin: 0;\n            }\n\n            &:last-of-type {\n              p {\n                padding: 0;\n              }\n            }\n          }\n\n          p {\n            color: #617385;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 23.3px;\n            padding-bottom: 20px;\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n\n            &:last-child {\n              padding: 0;\n            }\n          }\n\n          .arrow {\n            border: 1px solid #617385;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n\n          &.small {\n            padding: 8px 15px;\n            min-height: 40px;\n            margin-bottom: 0 !important;\n          }\n          &.balance {\n            flex-direction: column;\n\n            .header {\n              width: 100%;\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n            }\n            .has-balance {\n              width: 100%;\n              margin-top: 5px;\n            }\n            p {\n              padding: 0;\n              margin: 0 0 2px;\n              font: {\n                size: 13px;\n              }\n              line-height: 1.3;\n              color: #617385;\n            }\n\n            &.has-balance {\n              min-height: 100px;\n            }\n            &.small {\n              min-height: 56px;\n              margin-bottom: 60px !important;\n              justify-content: center;\n              align-items: start;\n            }\n          }\n        }\n        &.title {\n          min-width: 100%;\n        }\n        &.dynamic {\n          .exits {\n            .card-flux {\n              margin-bottom: 8px;\n            }\n          }\n        }\n      }\n\n      .SettingsSliderCashFlow {\n        &.slick-slider {\n          margin: 0 -16px !important;\n        }\n        .slick-track {\n          display: flex !important;\n        }\n        .slick-slide {\n          height: inherit !important;\n\n          div:first-child {\n            height: 100%;\n          }\n        }\n        .slick {\n          &-list {\n            .wrapper-flux {\n              padding-left: 15px;\n            }\n          }\n\n          &-dots {\n            position: relative;\n            bottom: 0;\n\n            li {\n              width: 18px;\n              height: 10px;\n              button {\n                background-color: #005eb8;\n                border-radius: 50%;\n                opacity: 1;\n                width: 10px;\n                height: 10px;\n                transition: 0.3s;\n                font-size: 1px;\n\n                &:before {\n                  content: none;\n                }\n              }\n              &.slick-active {\n                button {\n                  border-radius: 66.667px;\n                  width: 18px;\n                }\n              }\n            }\n          }\n\n          @media (min-width: 767px) {\n            &-list {\n              overflow: visible;\n            }\n          }\n        }\n        .wrapper-flux {\n          position: relative;\n          height: 100%;\n          padding-bottom: 72px;\n\n          .capacity {\n            position: absolute;\n            bottom: 16px;\n            left: 0;\n            right: 0;\n            width: calc(100% - 15px);\n            margin: 0 0 0 auto;\n            padding: 10px 16px;\n          }\n        }\n        &.empty {\n          .wrapper-flux {\n            padding-left: 0;\n\n            .capacity {\n              width: 100%;\n            }\n          }\n        }\n      }\n\n      .label-installments {\n        padding: 10px 0;\n        border-top: 1px solid #e0e5eb;\n        margin-top: 16px;\n      }\n\n      .form {\n        &-date {\n          .description {\n            font-weight: 600;\n            span {\n              color: #243342;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 400;\n              line-height: 23.3px;\n              display: block;\n              padding-top: 16px;\n            }\n          }\n          label {\n            color: #617385 !important;\n            font-size: 15px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n            padding-bottom: 5px;\n          }\n        }\n\n        &-initial-values {\n          .description {\n            font-weight: 500;\n            padding-bottom: 16px;\n          }\n\n          .wrapper-date {\n            max-width: 50%;\n            margin-bottom: 16px;\n          }\n\n          label {\n            color: #617385 !important;\n            font-size: 15px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n            padding-bottom: 5px;\n          }\n        }\n      }\n\n      .date {\n        .currency {\n          padding: 10px 0 0;\n        }\n\n        .wrapper-date {\n          display: flex;\n          gap: 20px;\n\n          & > div {\n            width: 100%;\n          }\n        }\n      }\n\n      .BaSe--checkbox {\n        div {\n          &:last-child {\n            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n\n      .additional-month {\n        max-height: 400px;\n        overflow: auto;\n        padding-right: 15px;\n        margin-right: -10px;\n        margin-top: 15px;\n      }\n\n      .wrapper-button {\n        padding: 20px 0 10px;\n        text-align: right;\n\n        button {\n          background-color: var(--sebrae-blue);\n          color: var(--sebrae-white);\n          border-radius: 4px;\n          height: 40px;\n          padding: 0 15px;\n        }\n      }\n\n      button {\n        &:disabled {\n          opacity: 0.7;\n          cursor: no-drop;\n        }\n      }\n\n      @media (min-width: 767px) {\n        .wrapper-flux {\n          min-width: 286px;\n        }\n        .additional-month {\n          display: grid;\n          grid-template-columns: 1fr 1fr;\n          gap: 0 16px;\n        }\n        .wrapper-button {\n          text-align: left;\n        }\n      }\n    }\n  }\n  &__footer {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    padding: 16px;\n    width: 100%;\n    z-index: 2;\n    background-color: var(--sebrae-white-2);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 15px;\n\n    &.start {\n      justify-content: flex-end;\n    }\n\n    @media screen and (min-width: 560px) {\n      padding-left: 86px;\n    }\n  }\n  .group-input {\n    border-bottom: 1px solid var(--sebrae-light-gray-2);\n    &.desktop {\n      border: none;\n    }\n\n    @media screen and (min-width: 1280px) {\n      &.desktop {\n        border-bottom: 1px solid var(--sebrae-light-gray-2);\n      }\n      &.mobile {\n        border: none;\n      }\n    }\n  }\n  .fampe-range {\n    .custom-input-range {\n      .input-range {\n        .input-range__wrapper-input {\n          &::-webkit-slider-runnable-track {\n            background: green;\n          }\n        }\n      }\n    }\n  }\n  .BaSe--grid {\n    gap: 16px;\n  }\n  .finish-and-download {\n    display: none;\n    //position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: 0 auto 8px;\n    width: 100%;\n    //width: calc(100% - 32px);\n    justify-content: center;\n    align-items: center;\n    height: 48px;\n    border-radius: 4px;\n    gap: 8px;\n\n    p {\n      color: var(--sebrae-white);\n      margin: 0;\n    }\n\n    &.disabled {\n      border: none;\n      background: #b6bfc8;\n      cursor: not-allowed;\n    }\n    &.finish {\n      border: none;\n      background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);\n    }\n    &.download {\n      border: 2px solid #e0e5eb;\n      background: #f5f7fa;\n\n      p {\n        color: #243342;\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .steps {\n      display: flex;\n      min-height: 100vh;\n      padding: 0;\n\n      .steps__header {\n        position: relative;\n        width: 100%;\n        max-width: 326px;\n        padding: 60px 16px 24px;\n        background: var(--sebrae-light-gray-2);\n\n        .content_header {\n          position: fixed;\n          max-width: 294px;\n          width: 100%;\n        }\n\n        ul {\n          li {\n            height: 48px;\n            margin-bottom: 8px;\n            border-radius: 4px;\n\n            p {\n              font-size: 16px;\n              visibility: visible;\n            }\n\n            @each $idx, $color in $colors {\n              &:nth-child(#{$idx}) {\n                background-color: $color !important;\n                border-color: $color !important;\n                color: $color !important;\n\n                &.is-completed {\n                  background-color: transparent !important;\n                  border-color: $color !important;\n                  color: $color !important;\n                  cursor: pointer;\n                }\n                &.active {\n                  background-color: $color !important;\n                  border-color: $color !important;\n                  color: var(--sebrae-white) !important;\n                }\n              }\n            }\n            &.has-name {\n              height: 48px;\n            }\n          }\n          li:not(.active) {\n            background-color: transparent !important;\n            border-color: #b6bfc8 !important;\n            color: #b6bfc8 !important;\n          }\n        }\n      }\n      .steps__body {\n        position: relative;\n        width: 100%;\n        padding: 45px 16px 80px;\n        overflow: hidden;\n      }\n      .step {\n        h5 {\n          font-size: 23px;\n        }\n      }\n    }\n    &__footer {\n      position: absolute;\n      padding: 16px;\n    }\n    .finish-and-download {\n      display: flex !important;\n    }\n  }\n  @media screen and (min-width: 1366px) {\n    .steps {\n      .steps__body {\n        padding: 15px 100px 24px 16px;\n\n        .step {\n          margin-top: 30px;\n        }\n      }\n    }\n    &__footer {\n      padding-right: 116px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
